import type { FC } from 'react';

import { BarChartIcon } from '@/assets';
import { LabelButton } from '@/features/posts/components/LabelButton';
import { PostsRoute } from '@/features/posts/navigation/postsRoute';
import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';

type Props = {
  postId?: string;
  voterCount?: number;
};

export const PollChip: FC<Props> = ({ postId = '', voterCount = 0 }) => {
  const navigation = useAppNavigation();

  return (
    <LabelButton
      testID={`post-poll-chip-${postId}`}
      onPress={() =>
        postId && navigation.navigate(PostsRoute.PostDetail, { id: postId })
      }
      rippleColor="transparent"
      icon={({ color, size }) => (
        <BarChartIcon fill={color} width={size} height={size} />
      )}
    >
      {voterCount}
    </LabelButton>
  );
};
